module.exports = __webpack_public_path__ + "img/blue_110.44cb7e95.png";